export type OrderStatus = 'OPEN' | 'CHECKED' | 'RELEASED'

const STATUS_FRE = 'CSO_TIM_STA_FRE'
const STATUS_CHK = 'CSO_TIM_STA_CHK'

export const classifyOrderStatus = (statuses: Set<string>): OrderStatus => {
  if (statuses.size === 0) return 'OPEN'
  const arr = Array.from(statuses)
  if (arr.every((s) => s === STATUS_FRE)) return 'RELEASED'
  if (arr.every((s) => s === STATUS_CHK || s === STATUS_FRE)) return 'CHECKED'
  return 'OPEN'
}
